export default __webpack_public_path__ + "static/media/blabber2.97f95383.PNG";